// Функция отправляет событие нахождения человека на вебинаре

import getGaCid from '~/utils/getGaCid';

export default {
  data() {
    return {
      saveAndSendMetadataIntervalTimer: null,
      clearSaveAndSendMetadataTimer: null,
    };
  },
  beforeDestroy() {
    clearInterval(this.saveAndSendMetadataIntervalTimer);
    clearTimeout(this.clearSaveAndSendMetadataTimer);
  },
  methods: {
    saveAndSendMetadata({ clearTimerTime = 0, selectedTopic }) {
      this.saveAndSendMetadataIntervalTimer = setInterval(async () => {
        const maxAge = 60 * 60 * 24 * 365;
        document.cookie = `last_schedule_event=${selectedTopic.eventScheduleId}; path=/; domain=${window.location.hostname}; max-age=${maxAge}; secure`;
        this.$app.cookies.lastScheduleEvent = this.$app.getCookie(
          'last_schedule_event',
        );

        const data = {
          event_id: selectedTopic.eventScheduleId,
          topic_id: selectedTopic.id,
          broadcast_id: selectedTopic.youtubeBroadcastId,
          created: this.$dayjs().utc().format(),
          country: this.$app?.config?.common?.currentCountry?.toUpperCase(),
          ...(this.$app.user && {
            user_id: this.$app.user.id,
          }),
        };

        const gaCid = getGaCid();
        if (gaCid) {
          data['ga_cid'] = gaCid;
        }

        // Save data to redshift (if `webinarVisitorEventsUrl` is presented in the config)
        const webinarVisitorEventsUrl =
          this.$app.config.current.webinarVisitorEventsUrl;
        if (webinarVisitorEventsUrl) {
          try {
            await this.$axios({
              method: 'POST',
              url: webinarVisitorEventsUrl,
              data: data,
            });
          } catch (err) {
            console.error(err);
          }
        }
      }, 1000 * 60);

      this.clearSaveAndSendMetadataTimer = setTimeout(() => {
        clearInterval(this.saveAndSendMetadataIntervalTimer);
      }, clearTimerTime);
    },
  },
};
